import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m14.999 8.334-3.334-3.333M2.082 17.918l2.82-.314c.345-.038.517-.057.678-.11q.216-.07.404-.194c.142-.093.264-.215.51-.46L17.498 5.834a2.357 2.357 0 1 0-3.334-3.333L3.16 13.506c-.245.245-.368.368-.46.51a1.7 1.7 0 0 0-.195.403c-.052.161-.071.334-.11.678z"
    }, null, -1)
  ])))
}
export default { render: render }